import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { PayCodeStateClass } from './interfaces/payCodeStateClass'
const initialState: PayCodeStateClass = {
    isLoading: false,
    status: 'idle',
    payCodeList: [],
    selectedRecord: {},
    isReload: false
}
interface IThunkApi {
    state: {
        payCode: PayCodeStateClass;
    },
}
export const getPayCodeDatatableAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'payCode/getPayCodeDatatable',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/PayCode/PayCodeDatatable', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const getPayCodeByIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payCode/getPayCodeById',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/PayCode/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const addPayCodeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payCode/addPayCode',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PayCode/', 'POST', arg, true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

export const updatePayCodeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payCode/updatePayCode',
        async (arg, thunkApi) => {
            const { AccountPayCodeId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/PayCode/' + AccountPayCodeId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const deletePayCodeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payCode/deletePayCode',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PayCode/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAllSelectedRecordPayCodeAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "payCode/DeleteAllSelectedRecordPayCode",
        async(arg,thunkApi) =>{
            const response = await fetchAPI('api/v2/PayCode/DeleteSelected/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        }
    )


export const payCodeSlice = createSlice({
    name: 'payCode',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.payCodeList.findIndex((item) => item.AccountPayCodeId == action.payload);
            const newArray = [...state.payCodeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.payCodeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.payCodeList.findIndex((item) => item.AccountPayCodeId == action.payload);
            const newArray = [...state.payCodeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.payCodeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.payCodeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.payCodeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.payCodeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.payCodeList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPayCodeDatatableAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getPayCodeDatatableAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.payCodeList = payload;
                state.payCodeList.map((item: any) => {
                    item.isSelected = 0
                });
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
              
            })
            .addCase(getPayCodeDatatableAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getPayCodeByIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getPayCodeByIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data[0];
            })
            .addCase(getPayCodeByIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addPayCodeAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addPayCodeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(addPayCodeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updatePayCodeAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatePayCodeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(updatePayCodeAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deletePayCodeAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletePayCodeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(deletePayCodeAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAllSelectedRecordPayCodeAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAllSelectedRecordPayCodeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(deleteAllSelectedRecordPayCodeAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }
})
export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState
} = payCodeSlice.actions
export const PayCodeState = (state: RootState) => state.payCode
export default payCodeSlice.reducer